import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setFooterVisibility } from "../components/formSettings.slice";

export const useHideFooter = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFooterVisibility(false));
  }, [dispatch]);
};
